import { CreateCustomerProfileDto } from '../../../api/models/CreateCustomerProfileDto';
import { toTitleCase } from '../../../utils/formatters/text';
import type { ClientDrawerFormState } from './clientCreateDrawer.types';

export function emptyClientDrawerForm(): ClientDrawerFormState {
  return {
    customerName: '',
    identityDocumentNumber: '',
    customerEmail: '',
    customerPhone: '',
    referenceNumber1: '',
    referenceNumber2: '',
    customerAddress: '',
    dateOfBirth: '',
    gender: '',
    preferredPaymentMethod: '',
    customerNotes: '',
    loyaltyTier: CreateCustomerProfileDto.loyaltyTier.BRONZE,
    marketingConsent: false,
    referralSource: '',
  };
}

export function parseClientDrawerApiErrorMessage(body: unknown): string {
  if (body == null || typeof body !== 'object') return '';
  const msg = (body as { message?: unknown }).message;
  if (Array.isArray(msg)) return msg.map(String).join(' ');
  if (typeof msg === 'string') return msg;
  return '';
}

export function normalizeClientGender(value: unknown): '' | CreateCustomerProfileDto.gender {
  if (
    value === CreateCustomerProfileDto.gender.MALE ||
    value === CreateCustomerProfileDto.gender.FEMALE ||
    value === CreateCustomerProfileDto.gender.OTHER
  ) {
    return value;
  }
  return '';
}

export function normalizeClientPaymentMethod(
  value: unknown,
): '' | CreateCustomerProfileDto.preferredPaymentMethod {
  if (
    value === CreateCustomerProfileDto.preferredPaymentMethod.CASH ||
    value === CreateCustomerProfileDto.preferredPaymentMethod.CARD ||
    value === CreateCustomerProfileDto.preferredPaymentMethod.BANK_TRANSFER ||
    value === CreateCustomerProfileDto.preferredPaymentMethod.QR_CODE
  ) {
    return value;
  }
  return '';
}

export function buildCreateCustomerDto(form: ClientDrawerFormState): CreateCustomerProfileDto {
  const idn = form.identityDocumentNumber.trim();
  const dto: CreateCustomerProfileDto = {
    customerName: toTitleCase(form.customerName),
    identityDocumentNumber: idn,
    marketingConsent: form.marketingConsent,
    loyaltyTier: form.loyaltyTier,
  };
  if (form.customerEmail.trim()) dto.customerEmail = form.customerEmail.trim();
  if (form.customerPhone.trim()) dto.customerPhone = form.customerPhone.trim();
  if (form.referenceNumber1.trim()) dto.referenceNumber1 = form.referenceNumber1.trim();
  if (form.referenceNumber2.trim()) dto.referenceNumber2 = form.referenceNumber2.trim();
  if (form.customerAddress.trim()) dto.customerAddress = form.customerAddress.trim();
  if (form.dateOfBirth) dto.dateOfBirth = form.dateOfBirth;
  if (form.gender) dto.gender = form.gender;
  if (form.preferredPaymentMethod) dto.preferredPaymentMethod = form.preferredPaymentMethod;
  if (form.customerNotes.trim()) dto.customerNotes = form.customerNotes.trim();
  if (form.referralSource.trim()) dto.referralSource = form.referralSource.trim();
  return dto;
}
